import { useQuery } from '@tanstack/react-query';
import useLocalStorage from './useLocalStorage';
import { Pose } from '../models';
import QueryKeys from '../utils/QueryKeys';

export default function usePngPoses(studentId, packageId, pastImages = false) {
  const [currentSeason] = useLocalStorage(`currentSeason-${studentId}`);

  return useQuery(
    [QueryKeys.STUDENT_IMAGES, studentId, packageId, false, currentSeason, 'singleSeason'],
    () => {
      return Pose
        .selectExtra(['folder'])
        .where({ forPackage: [packageId, studentId] })
        .all()
        .then((res) => {
          if (!res.data) return [];

          // Filter poses to only include .png files
          return res.data.filter(pose =>
            pose.imageFileName && pose.imageFileName.toLowerCase().endsWith('.png')
          );
        });
    },
    { placeholderData: [], enabled: !!(studentId && packageId) }
  );
}